import { Identifiable, Project, resource, Resource } from "@planzone/dto";

type SpentTime = {
  date: string;
  time: number;
  isAvailable: boolean;
};

type PersonalTimeSheet = {
  spentTimes: SpentTime[];
  timesheetDeadline: string;
  resource: Identifiable<Resource> & {
    integratedAt: string;
    totalOfAllocatedHours: number;
    totalOfSpentTime: number;
    totalOfSpentTimeInWeek: number;
    totalOfRemainingTime: number;
    percentCompletion: number;
    spentTimes: SpentTime[];
    validatedSpentTimes: SpentTime[];
  };
  projects: (Identifiable<Project> & {
    integratedAt: string;
    deactivated: boolean;
    resourceRemoved?: boolean;
    totalOfAllocatedHours: number;
    totalOfSpentTime: number;
    totalOfSpentTimeInWeek: number;
    totalOfRemainingTime: number;
    spentTimes: SpentTime[];
  })[];
};

const personalTimeSheet: PersonalTimeSheet = {
  spentTimes: [],
  timesheetDeadline: "",
  resource: {
    ...resource,
    uuid: "",
    integratedAt: "",
    totalOfAllocatedHours: 0,
    totalOfSpentTime: 0,
    totalOfSpentTimeInWeek: 0,
    totalOfRemainingTime: 0,
    percentCompletion: 0,
    spentTimes: [],
    validatedSpentTimes: [],
  },
  projects: [],
};

export type { PersonalTimeSheet };

export { personalTimeSheet };
